import { NavLink } from "react-router-dom";
import { useT } from "@/contexts/I18nContext";

/**
 * Four views of one thing.
 *
 * Separate routes rather than tab state, because the coverage queue is
 * somewhere a support person lives for an afternoon and needs to be able to
 * send a colleague a link to.
 */
const TABS = [
  { to: "/legal", key: "legal.tab.documents", end: true },
  { to: "/legal/matrix", key: "legal.tab.matrix", end: false },
  { to: "/legal/acceptances", key: "legal.tab.acceptances", end: false },
  { to: "/legal/coverage", key: "legal.tab.coverage", end: false },
] as const;

export function LegalTabs() {
  const t = useT();

  return (
    <nav aria-label={t("legal.tabs")} className="mb-8 border-b border-paper-deep">
      <ul className="flex flex-wrap gap-1">
        {TABS.map((tab) => (
          <li key={tab.to}>
            <NavLink
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `-mb-px inline-block border-b-2 px-4 py-2.5 text-sm ${
                  isActive
                    ? "border-cue-green font-medium text-ink"
                    : "border-transparent text-ink-muted hover:text-ink"
                }`
              }
            >
              {t(tab.key)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
